import { UseAuthContextType } from './auth.types';

export const getDefaultUseAuthState = (
  opts: Partial<UseAuthContextType> = {},
): UseAuthContextType => ({
  isAuthenticated: false,
  isLoading: false,
  loginWithPopup: () => Promise.resolve(),
  loginWithRedirect: () => Promise.resolve(),
  getAccessTokenSilently: () => Promise.resolve(''),
  logout: () => Promise.resolve(),
  user: { name: 'default', picture: undefined, email: 'email@email.com' },
  ...opts,
});
